export const paths = {
    requestCancelMeeting: "/request-cancel",
    joinMeeting: "/join",
};
